import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';
import { Roles } from '../../commonType';
import ErrorMessage from '../../components/common/ErrorMessage';
import withRoles from '../../components/hoc/withRoles';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import Comments from '../../components/OfferSummary/Comments';
import ConfirmationHeader from '../../components/OfferSummary/ConfirmationHeader';
import ConfirmationSelector from '../../components/OfferSummary/ConfirmationSelector';
import ContactInformationReview from '../../components/OfferSummary/ContactInformationReview';
import PackageSummaryReview from '../../components/OfferSummary/PackageSummaryReview';
import ProspectMembership from '../../components/OfferSummary/ProspectMembership';
import { isSessionExpired } from '../../redux/middleware';
import { RootState } from '../../redux/rootReducer';
import { OFFER_CONFIRMATION_PATH, OFFER_CONTACT_INFO_PATH } from '../../util/strings';
import {
  resetPaymentContextId,
  setPaymentButtonState,
  // eslint-disable-next-line prettier/prettier
  setPaymentcheckBox
} from '../offerConfirmation/offerConfirmationSlice';
import { setNavigationStep } from '../offerSearch/offerSearchSlice';

const OfferSummaryContainer: FC<any> = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const confirmationState = useSelector((state: RootState) => state.confirmation);
  const confNumber = confirmationState.ConfirmationNumber;
  const hasError = confirmationState.hasError;
  const error = hasError ? <ErrorMessage errorObject={confirmationState.error}></ErrorMessage> : <></>;
  const lastActiveTime = useSelector((state: RootState) => state.sessionManager).lastActiveTime;
  const jwtPaymentToken = useSelector((state: RootState) => state.confirmation.transientTokenJwt);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setNavigationStep(NavigationSteps.OFFER_REVIEW));
    dispatch(setPaymentButtonState(false));
    dispatch(setPaymentcheckBox(false));
    dispatch(resetPaymentContextId());
  }, [dispatch]);
  useEffect(() => {
    if (!hasError && confNumber && confNumber.length > 0) {
      props.history.push(OFFER_CONFIRMATION_PATH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasError, confNumber]);
  useEffect(() => {
    if (props.userRole === Roles.Field_Associate) {
      if (!jwtPaymentToken || jwtPaymentToken.length === 0) {
        props.history.push(OFFER_CONTACT_INFO_PATH);
      }
    }
  }, [jwtPaymentToken, props.history, props.userRole]);
  return (
    <>
      <div className="container">
        <Prompt when={true} message={() => !isSessionExpired(lastActiveTime)}></Prompt>
        {error}
        <ConfirmationHeader />
        <div className="row">
          <div className="col-sm-12">
            <ProspectMembership></ProspectMembership>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <ContactInformationReview />
          </div>
          <div className="col-sm-6">
            <PackageSummaryReview />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Comments />
          </div>
        </div>
        <ConfirmationSelector />
      </div>
    </>
  );
};
export default withRouter(withRoles(OfferSummaryContainer));
